import React, { createContext, useState, useContext } from 'react';

const BookingContext = createContext();

export const useBooking = () => {
  const context = useContext(BookingContext);
  if (!context) {
    throw new Error('useBooking must be used within BookingProvider');
  }
  return context;
};

export const BookingProvider = ({ children }) => {
  const [bookingData, setBookingData] = useState({
    service: null,
    customer: {
      name: '',
      email: '',
      phone: '',
    },
    vehicle: {
      make: '',
      model: '',
      year: '',
      rego: '',
      odometer: '',
    },
    schedule: {
      preferredDate: '',
      preferredTime: '',
      alternativeDate: '',
      alternativeTime: '',
    },
    notes: '',
  });

  const [isModalOpen, setIsModalOpen] = useState(false);

  const updateBookingData = (field, value) => {
    setBookingData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const resetBooking = () => {
    setBookingData({
      service: null,
      customer: { name: '', email: '', phone: '' },
      vehicle: { make: '', model: '', year: '', rego: '', odometer: '' },
      schedule: { preferredDate: '', preferredTime: '', alternativeDate: '', alternativeTime: '' },
      notes: '',
    });
  };

  const openBookingModal = () => setIsModalOpen(true);

  const closeBookingModal = () => {
    setIsModalOpen(false);
  };

  return (
    <BookingContext.Provider
      value={{
        bookingData,
        updateBookingData,
        resetBooking,
        isModalOpen,
        openBookingModal,
        closeBookingModal,
      }}
    >
      {children}
    </BookingContext.Provider>
  );
};
